import React from 'react';
import { ListItemIcon, ListItemText, Tooltip } from '@mui/material';
import { ISideMenuData } from './SideMenu.types';
import { Link } from 'react-router';
import MuiListItemButton from '@mui/material/ListItemButton';
import { useSideMenuProvider } from './SideMenuProvider';

/*
*   Боковое меню: верстка одного элемента в списке
*/

type ISideMenuDrawerListItem = {
    selected: boolean,
} & ISideMenuData


export default function SideMenuDrawerListItem({ icon, label, link, selected }: ISideMenuDrawerListItem) {
    const { openSideMenu } = useSideMenuProvider();

    return (
        <Tooltip title={label}
            placement="right"
            disableHoverListener={openSideMenu}>
            <MuiListItemButton to={link}
                selected={selected}
                component={Link} >
                <ListItemIcon>
                    <>{icon}</>
                </ListItemIcon>
                <ListItemText primary={label} />
            </MuiListItemButton>
        </Tooltip>
    );
} 